import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { ErrorBoundary } from '@/components/common/error-boundary'
import { Skeleton } from '@/components/ui/skeleton'

const DetailsLogs = lazy(
	() => import('@/features/air/case-management/components/details/logs'),
)

export const Route = createFileRoute(
	'/_dashboard/air/case-management/$id/logs',
)({
	head: ({ params }) => ({
		meta: [
			{
				title: `Logs · Case ${params.id} | Case Management | BitLyft AIR®`,
			},
		],
	}),
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()

	return (
		<ErrorBoundary feature="case-management" section="logs" entityId={id}>
			<Suspense fallback={<Skeleton className="h-32 w-full" />}>
				<DetailsLogs id={id} />
			</Suspense>
		</ErrorBoundary>
	)
}
